<template>
  <div class="ine-form__form-wrapper">
    <form @submit.prevent="validateFields" class="suspend-user ine-form__form">
      <div class="suspend-user__toggle-suspension-wrapper">
        <button
          :class="[
            'suspend-user__toggle-suspension-btn',
            suspend && 'suspend-user__chosen',
          ]"
          @click.prevent="suspend = true"
        >
          Suspend a User
        </button>
        <button
          :class="[
            'suspend-user__toggle-suspension-btn',
            !suspend && 'suspend-user__chosen',
          ]"
          @click.prevent="suspend = false"
        >
          Lift User Suspension
        </button>
      </div>
      <Title
        :header="suspend ? 'Suspend User' : 'Lift a Suspension'"
        tagline="Please enter the users email address"
      />
      <Errors :errors="errors.messages" />
      <div
        v-for="(field, key) in fields"
        v-show="field.type"
        :key="`field-${key}`"
        class="ine-form__form-group"
      >
        <input
          v-if="field.type"
          :type="field.type"
          :class="[
            'ine-form__form-control',
            errors.fields.includes(key) && 'ine-form__form-control--error',
          ]"
          @focus="clearErrors"
          :placeholder="field.placeholder"
          :autocomplete="field.autocomplete"
          v-model="field.value"
        />
      </div>
      <div class="ine-form__actions">
        <SubmitBtn
          title="Submit"
          :iconName="suspend ? 'lock' : 'lock_open'"
          :isLoading="isLoading"
        />
      </div>
      <AdditionalLinks :linksShown="[]" />
    </form>
  </div>
</template>

<script>
import { validateForm, clearFormErrors } from '@/helpers'
import Title from '@/components/forms/elements/Title.vue'
import Errors from '@/components/forms/elements/Errors.vue'
import SubmitBtn from '@/components/forms/elements/SubmitBtn.vue'
import AdditionalLinks from '@/components/forms/elements/AdditionalLinks.vue'

export default {
  name: 'ManageSuspensionForm',
  components: {
    Title,
    Errors,
    SubmitBtn,
    AdditionalLinks,
  },
  data() {
    return {
      errors: clearFormErrors(),
      fields: {
        email: {
          type: 'email',
          placeholder: 'Email',
          rules: ['presence'],
          value: '',
          autocomplete: 'email',
        },
      },
      suspend: true,
      isLoading: false,
    }
  },
  methods: {
    async validateFields() {
      const { fields } = this
      const { isValid, errors } = validateForm(fields)
      this.errors = errors
      if (isValid) {
        const email = fields.email.value
        if (this.suspend) {
          await this.suspendUser(email)
        } else {
          await this.liftSuspension(email)
        }
      }
    },
    async suspendUser(email) {
      this.isLoading = true
      await this.$store.dispatch('admin/adminSuspendUser', email)
      this.isLoading = false
    },
    async liftSuspension(email) {
      this.isLoading = true
      await this.$store.dispatch('admin/adminLiftSuspension', email)
      this.isLoading = false
    },
    clearErrors() {
      this.errors = clearFormErrors()
    },
  },
}
</script>

<style lang="scss" scoped>
.suspend-user {
  &__toggle-suspension-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 20px 0;
  }
  &__toggle-suspension-btn {
    border: 1px solid var(--black);
    background-color: var(--white);
    color: var(--black);
    padding: 5px 25px;
    cursor: pointer;
  }
  &__chosen {
    background-color: #ef7d21;
    color: #fff;
  }
}
</style>
